<template>
  <div>
    <span class="msgname">{{item.name}}</span>
    <span class="jiantou" @click="show(item.id)" >
      <img src="../assets/img/huiyiJiantou.png" alt :class="[rotate ?' go':' aa']">
    </span>
    <span v-if="showBox" class="msgm">{{item.iphone}}</span>
    <span v-if="showBox" class="msgm">{{item.job}}</span>
    <span v-if="showBox" class="msgmb">{{item.email}}</span> 
  </div>
</template>
<script>
export default {
  name: 'msgshow',
  props: ['item'],
  data() {
    return {
      showBox: false,
      rotate: false,
    };
  },
  mounted() {},
  methods: {
     show(id) {
      // this.isActive = !this.isActive;
      console.log("id", id);
      this.showBox = !this.showBox;
      this.rotate = !this.rotate
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.aa {
  transition: all 0.2s;
}
.go {
  transform: rotate(90deg);
//  transform-origin: -.6px; 
  transition: all 0.2s;
}

.jiantou {
  position: absolute;
  -webkit-tap-highlight-color: transparent;
  top: 2px;
  right: 17px;
  width: 10.2px;
  img {
    width: 100%;
    height: auto;
  }
}
.msgmb {
  display: block;
  font-size: 13px;
  color: #797979;
  margin-bottom: 9px;
}
.msgm {
  display: block;
  font-size: 13px;
  color: #797979;
  margin: 0 0 5px 0;
}
.msgname {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: #232323;
}
.msgboxin {
  position: relative;
  padding: 0 18px;
}
.participants {
  display: block;
  font-size: 12px;
  margin: 18px 0 4px 18px;
  color: #797979;
}
.enterprise {
  display: block;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 0 18px;
  color: #232323;
}
.participatingEnterprises {
  display: block;
  font-size: 12px;
  margin: 10px 0 4px 18px;
  color: #797979;
}
.msgbox {
  width: 346px;
  // height: 260px;
  background: #ffffff;
  border-radius: 7px;
  margin: 18px auto;
  text-align: left;
  border: 1px solid transparent;
  padding-bottom: 7px;
}
.time {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #797979;
  letter-spacing: 0;
  margin-left: 18px;
  padding-bottom: 9px;
}
.place {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #797979;
  letter-spacing: 0;
  margin-left: 18px;
  padding-bottom: 16px;
}
.titlebox {
  position: relative;
  width: 346px;
  // height: 102px;
  background: #ffffff;
  border-radius: 7px;
  margin: 18px auto;
  text-align: left;
  .iosimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 21px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
  .androidimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 19px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
}
.title {
  display: inline-block;
  margin: 16px 8px 9px 28px;
  font-size: 16px;
  font-weight: 700;
  color: #232323;
  letter-spacing: 0;
}

.box {
  height: 56px;
}

.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    width: 133px;
    height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.btn {
  position: fixed;
  bottom: 24px;
  left: 105px;
  height: 60px;
  margin-top: 110px;
  .button {
    display: block;
    color: #fff;
    width: 165px;
    height: 42px;
    font-size: 16px;
    line-height: 42px;
    background-image: linear-gradient(190deg, #5fd5f9 0%, #31aaf1 100%);
    box-shadow: 0 3px 9px 0 #9cdbff;
    border-radius: 25px;
    text-align: center;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/msgshow.vue